import React from 'react';
import { Paper, SxProps } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { useContext } from 'react';
import loginBackground from 'shared/assets/images/loginBackground.png';
import { borderRadiusValues } from 'shared/lib/utils/uiConstants';

export type LoginPageFormType = 'login' | 'invite' | 'restore';

export default observer(function LoginContainer({
  children,
  sx,
  innerSx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
  innerSx?: SxProps;
}) {
  const {
    spacings: { sp, loginPage },
  } = useContext(UiContext);

  return (
    <Paper
      square
      elevation={0}
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundImage: `url(${loginBackground}), linear-gradient(180deg, #472183 0%, #7025ce 100%)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
        px: {
          mobile: 5,
          tablet: 14,
        },
        ...sx,
      }}
    >
      <Paper
        elevation={5}
        sx={{
          padding: {
            mobile: 6,
            tablet: sp.s100,
          },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: sp.s75,
          width: {
            mobile: 1,
            tablet: 1,
            laptop: loginPage.loginForm.w,
          },
          borderRadius: borderRadiusValues.large,
          ...innerSx,
        }}
      >
        {children}
      </Paper>
    </Paper>
  );
});
